export type SnackbarAlertState = {
	isOpen: boolean;
	message: string;
	severity: "error" | "warning" | "info" | "success";
};

export const snackBarAlerts = {
	closed: {
		isOpen: false,
		message: "",
		severity: "info",
	} as SnackbarAlertState,
	error: {
		savingReceive: {
			isOpen: true,
			message: "There was an error saving receive",
			severity: "error",
		} as SnackbarAlertState,
		finalisingReceive: {
			isOpen: true,
			message: "There was an error finalising receive",
			severity: "error",
		} as SnackbarAlertState,
		loading: {
			isOpen: true,
			message: "",
			severity: "error",
		} as SnackbarAlertState,
		savingArrival: {
			isOpen: true,
			message: "There was an error submitting arrival",
			severity: "error",
		} as SnackbarAlertState,
	},
	success: {
		savingReceive: {
			isOpen: true,
			message: "Receive saved successfully!",
			severity: "success",
		} as SnackbarAlertState,
		finalisedReceive: {
			isOpen: true,
			message: "Finalised receive successfully!",
			severity: "success",
		} as SnackbarAlertState,
		submittedReceive: {
			isOpen: true,
			message: "Submitted receive successfully!",
			severity: "success",
		} as SnackbarAlertState,
		savingArrival: {
			isOpen: true,
			message: "Arrival submitted successfully!",
			severity: "success",
		} as SnackbarAlertState,
	},
};
